import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "time-block",
    style: _normalizeStyle(_ctx.cssVars)
  }, _toDisplayString(_ctx.theme.project.name) + _toDisplayString(_ctx.theme.name ? ` - ${_ctx.theme.name}` : "") + " [" + _toDisplayString(Math.floor(_ctx.duration / 60)) + ":" + _toDisplayString(_ctx.duration % 60) + "] ", 5))
}